module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Ticket Star.78618c38.svg";